import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/thum_img/kp708b/sub5_1/f70471c106ff0384d9e155c605b65615_water__c1_w280_h397.jpg'


const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "width_wrap" }
const _hoisted_3 = { class: "body_content" }
const _hoisted_4 = { class: "menu-A-read-wrap" }
const _hoisted_5 = { class: "btn" }

import BoardNavbar from "@/views/product/expert/Navbar.vue";
import Banner from "@/components/Banner.vue";

import { watch } from "vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import { useRouter } from "vue-router";
import { useAuth } from "@/composables/useAuth";
import { useAlertDialog } from "@/composables/useAlert";

export default /*@__PURE__*/_defineComponent({
  __name: 'High',
  setup(__props) {

const useAlert = useAlertDialog();
const { isLoggedIn } = useAuth();
const router = useRouter();
watch(
  isLoggedIn,
  async (newValue) => {
    if (newValue === false) {
      await useAlert("회원전용 페이지 입니다. 로그인 후 이용해주세요.");
      // TODO : 단순히 뒤로 갈지 향후 확인 후 변경 가능.
      // router.back();
      router.push({ name: USER_ROUTES.Home.Name });
    }
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_n_space = _resolveComponent("n-space")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_unref(isLoggedIn))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(Banner, {
          title: "전문가교육",
          subtitle: "전문가교육",
          description: "학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>\n        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
        }),
        _createVNode(BoardNavbar),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[5] || (_cache[5] = _createElementVNode("h1", { class: "sub_subject" }, "전문가 과정", -1)),
            _createElementVNode("div", _hoisted_4, [
              _cache[3] || (_cache[3] = _createElementVNode("div", null, [
                _createElementVNode("ul", { class: "line line4" }, [
                  _createElementVNode("li", null, "다중재능코칭 전문가교육"),
                  _createElementVNode("li", null, [
                    _createElementVNode("dl", { class: "line2" }, [
                      _createElementVNode("dt", null, "제목"),
                      _createElementVNode("dd", null, "다중재능코칭전문가교육 - 고급과정")
                    ])
                  ])
                ])
              ], -1)),
              _createElementVNode("div", null, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createElementVNode("figure", null, [
                      _createVNode(_component_n_space, { justify: "center" }, {
                        default: _withCtx(() => _cache[0] || (_cache[0] = [
                          _createElementVNode("img", {
                            src: _imports_0,
                            alt: ""
                          }, null, -1)
                        ])),
                        _: 1
                      })
                    ])
                  ]),
                  _cache[1] || (_cache[1] = _createStaticVNode("<li data-v-a548a304><dl data-v-a548a304><dt data-v-a548a304>목적</dt><dd data-v-a548a304> 성장기 유소년, 청소년, 청년을 대상으로 최적의 학습 전략을 수립하고 진로를 안내하는 전문가 양성 교육과정으로, <br data-v-a548a304> 참여자의 PUTT2.0 결과 분석 및 활용 역량을 고도화하는데 목적이 있다. </dd></dl><dl data-v-a548a304><dt data-v-a548a304>목표</dt><dd data-v-a548a304> 목표1. 참여자는 PUTT의 시대정신과 철학을 바탕으로, ‘다중재능검사’의 가치와 의미를 이해, 전달하는 기량을 확장한다.<br data-v-a548a304> 목표2. 참여자는 PUTT2.0 결과분석을 통해, 개별 다중재능의 구조, 유형을 파악하여 체계적 학습진로코칭 기량을 확장한다.<br data-v-a548a304> 목표3. 참여자는 PUTT2.0 다양한 사례의 비교 분석을 통해, 풍부한 해석과 최적의 학습진로코칭 기량을 확장한다. </dd></dl><dl data-v-a548a304><dt data-v-a548a304>대상</dt><dd data-v-a548a304> • 교육학 및 심리학 관련 분야 전공자<br data-v-a548a304> • ‘PUTT2.0 학습진로상담’에 관심 있는 교육 및 진로 상담 경력 2년 이상 종사자<br data-v-a548a304> • ‘PUTT2.0 학습진로상담 전문가 교육: 초급과정’ 이수자 </dd></dl><dl class=\"line2\" data-v-a548a304><dt data-v-a548a304>구분·시수</dt><dd data-v-a548a304> 직무연수, 30시간 (사전 과정 6시간 + 집중 과정 23시간 + 필기시험 1시간) </dd></dl></li>", 1))
                ])
              ]),
              _cache[4] || (_cache[4] = _createStaticVNode("<div data-v-a548a304><ul class=\"line line4\" data-v-a548a304><li data-v-a548a304> 결과물<br data-v-a548a304> + 다중재능코칭전문가 2급 자격증 </li><li data-v-a548a304><dl class=\"line2\" data-v-a548a304><dt data-v-a548a304>구성</dt><dd data-v-a548a304> [사전 과정] <br data-v-a548a304> Ⅰ. 검사 체험 • PUTT2.0 검사 실시 • 검사 및 결과리포트 • 기존 검사와의 비교<br data-v-a548a304> [집중 과정] <br data-v-a548a304> Ⅱ. 학문적 배경 •21세기 철학과 핵심역량<br data-v-a548a304> Ⅲ. 개념모델 •측정과 평가 •검사의 개요 •결과리포트의 이해<br data-v-a548a304> Ⅳ. 결과 분석 및 상담 방법 •결과분석 이해 - 유형별 •상담 이해 – 수준별<br data-v-a548a304> ⅴ. 사례 분석 •사례 분석 – 참여자 •사례 분석 – 학생 •사례 분석 – 발표 •직업군 탐색, 발표 </dd></dl></li></ul></div><div data-v-a548a304><ul class=\"line box22\" data-v-a548a304><li data-v-a548a304> 강의<br data-v-a548a304> + 검사 개발자<br data-v-a548a304> + ‘PUTT2.0 학습진로상담 전문가교육: <br data-v-a548a304> 최고과정’ 이수자(1급 자격증 소지)<br data-v-a548a304></li><li data-v-a548a304><dl class=\"line2\" data-v-a548a304><dt data-v-a548a304>이수혜택</dt><dd data-v-a548a304> • ‘다중재능코칭전문가 2급 자격증’ 부여<br data-v-a548a304> • 검사 구매, 결과 해석 및 상담 자격<br data-v-a548a304> • 특강 자격: 학생 또는 학부모 </dd></dl></li></ul></div>", 2)),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_router_link, {
                  to: `${_unref(USER_ROUTES).Product.Expert.Expert.Path}`
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode("목록")
                  ])),
                  _: 1
                }, 8, ["to"])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})